import tailwindColors from "./tailwind.colors";

const theme = {
  borderRadius: 0,
  colors: {
    primary: tailwindColors.blueGray[600],
    primary75: tailwindColors.blueGray[500],
    primary50: tailwindColors.blueGray[400],
    primary25: tailwindColors.blueGray[200],
    danger: tailwindColors.red[500],
    dangerLight: tailwindColors.red[200],
    neutral0: tailwindColors.white,
    neutral5: tailwindColors.blueGray[50],
    neutral10: tailwindColors.blueGray[200],
    neutral20: tailwindColors.blueGray[300],
    neutral30: tailwindColors.blueGray[400],
    neutral40: tailwindColors.blueGray[500],
    neutral50: tailwindColors.blueGray[500],
    neutral60: tailwindColors.blueGray[600],
    neutral70: tailwindColors.blueGray[600],
    neutral80: tailwindColors.blueGray[600],
    neutral90: tailwindColors.blueGray[600],
  },
  spacing: { baseUnit: 2, controlHeight: "unset", menuGutter: 0 },
};

export default theme;
